import { Inject, Injectable } from '@angular/core';
import {BehaviorSubject, map, Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { urlApi } from './utils/apiConfig';

@Injectable({
  providedIn: 'root'
}
)
export class InitializerService {
  public title!:string;

  constructor(private http: HttpClient) {
  }

  public getStyle(hostSite: string): Observable<any> {
    return this.http.post(`${urlApi}/style`, { hostSite }, { headers: { 'Content-type': 'application/json' } })
  }

  public getVersion(): Observable<any>{
    return this.http.post(`${urlApi}/system/version`, { headers: { 'Content-type': 'application/json' } }).pipe(
      map((response: any) => response.version)
    )
  }
}
